"use client";
import {
  CustomerDetailRespDTO,
  FrogArticleDetailRespDTO,
} from "@/service/customer";
import { setStationTime } from "@/utils/time";
import { Spin } from "antd";
import classNames from "classnames";
import { memo, useEffect, useState } from "react";
import "./Index.scss";
import ArticleSwitch from "../ArticleSwitch/Index";
import HotArticles from "../HotArticles/Index";
import Marking from "../Marking/Index";
import queryString from "query-string";
import { api } from "@/service";
import { useMount } from "ahooks";
import { useAtom, useAtomValue } from "jotai";
import { CustomerDetail } from "@/model";
import { getCookieToken, isLogin } from "@/utils";
import { useLink } from "@/utils/router";
import { CustomerDetailRespDTO2 } from "@/model/CustomerDetail";
// import HotArtical from "./HotArtical";
import ArticalCategory from "./ArticalCategory";
import FixedBanner from "./FixedBanner";
import HotArticalList from "@/app/[lang]/media/newxx/components/HotArticalList";
import { useParams, useRouter } from "next/navigation";
import ShareComp from "./ShareComp/index";
import BreadCrumb from "@/app/[lang]/media/component/BreadCrumb/Index";
import { useTranslation } from "react-i18next";
import ArticleTableOfContents from "./ArticleTableOfContents/Index";
import ArticleProductEnhancer from "./ArticleProductEnhancer/Index";
import type { PublishedArticle } from "../../utils/publishedArticle";
import { Local } from "@/i18n/settings";

interface Props {
  frogArticle?: FrogArticleDetailRespDTO;
  publishedArticle: PublishedArticle;
  querys: { [key: string]: string | undefined };
  userInfo?: CustomerDetailRespDTO2;
}

/** 判断服务端首屏是否需要展示文章阅读限制。 */
const shouldShowArticleMarking = (
  frogArticle?: FrogArticleDetailRespDTO,
  userInfo?: CustomerDetailRespDTO2,
) => {
  /** 当前请求是否来自已登录客户。 */
  const isLoggedIn = Boolean(userInfo?.customerId);
  /** 当前客户的会员等级。 */
  const membershipLevel = userInfo?.membership?.templateLevel || 0;
  return (
    (frogArticle?.noLoginRestriction === 2 && !isLoggedIn) ||
    (frogArticle?.noMembershipRestriction === 2 && membershipLevel <= 1)
  );
};

/** 渲染文章正文、关联内容和阅读限制交互。 */
const ArticlesCont = ({
  frogArticle,
  publishedArticle,
  querys,
  userInfo,
}: Props) => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const [markingShow, setMarkingShow] = useState<boolean>(() =>
    shouldShowArticleMarking(frogArticle, userInfo),
  );
  const router = useRouter();

  useMount(() => {
    const imgList = document
      .getElementById("content-html")
      ?.querySelectorAll("img");
    console.log(imgList, "imgList");
    imgList?.forEach((item: any) => {
      if (item.dataset.href && item.dataset.href !== "") {
        item.onclick = () => {
          window.open(item.dataset.href);
        };
        item.style.cursor = "pointer";
      }
    });
    if (frogArticle?.frogArticleId) {
      api.customer.frog.articleCount({
        frogArticleId: frogArticle?.frogArticleId,
      });
      // 未登录
      if (!userInfo?.customerId && frogArticle.noLoginRestriction === 3) {
        router.push("/");
        return;
      }
      if (frogArticle.noMembershipRestriction === 3) {
        if (!userInfo?.customerId || !userInfo?.membership?.templateLevel) {
          router.push("/");
          return;
        }
        setMarkingShow(false);
      }

      if (
        frogArticle.noMembershipRestriction === 2 &&
        userInfo?.membership?.templateLevel &&
        userInfo?.membership?.templateLevel > 1
      ) {
        setMarkingShow(false);
        return;
      }
      if (frogArticle.noMembershipRestriction === 1) {
        if (frogArticle.noLoginRestriction === 1) {
          setMarkingShow(false);
          return;
        }
        if (frogArticle.noLoginRestriction === 2 && userInfo?.customerId) {
          setMarkingShow(false);
          return;
        }
        if (frogArticle.noLoginRestriction === 3) {
          setMarkingShow(false);
          return;
        }
      }
    }
  });
  const isCkbEditor = frogArticle?.articalVersionFlag === 1;
  console.log(isCkbEditor, "isCkbEditor");
  // markingShow 似乎有bug 这里包装一下
  const _markingShow =
    userInfo?.customerId && userInfo?.membership?.templateLevel
      ? false
      : markingShow;
  return (
    <>
      <BreadCrumb
        dataSource={[
          { title: "HOME", href: `/${lang}` },
          { title: t("青蛙频道列表"), href: `/${lang}/media` },
          { title: frogArticle?.frogArticleTitle, truncate: true },
        ]}
      />
      <div className="justify-center pad:flex pc:flex mo:block article-content mo:py-[20px] px-[12px] bg-[#fff]">
        <div className="pad:flex pc:flex mo:block pad:w-[1200px] pc:w-[1200px] pc:mt-[48px]">
          <div className="pc:w-[calc(1200px-378px)] mo:w-[100%] pad:w-[100%] pad:mr-[20px] ">
            <div className="pc:pr-[20px]">
              <div>
                <h1 className="content-title !text-[30px] !m-[0] mo:!text-[20px] font-[700] ">
                  {frogArticle?.frogArticleTitle}
                </h1>
                <div className="flex justify-between mb-[10px]">
                  {frogArticle?.frogArticleId !== 151 && (
                    <div className="mo:mt-[8px] mo:h-[20px] text-[#000]/[0.45] flex items-center gap-[4px]">
                      <img
                        style={{ height: "14px" }}
                        src={`https://static-jp.theckb.com/static-asset/client/_media/${
                          frogArticle.createTime === frogArticle.updateTime
                            ? "first_time"
                            : "update_time"
                        }.png`}
                        alt=""
                      />
                      {setStationTime(frogArticle?.updateTime)}
                    </div>
                  )}
                  {frogArticle.frogArticleId && (
                    <ShareComp frogArticle={frogArticle} />
                  )}
                </div>
                <div
                  className={`${
                    _markingShow ? "max-h-[100vh] overflow-hidden" : ""
                  }`}
                >
                  <ArticleProductEnhancer
                    articleId={frogArticle?.frogArticleId}
                  />
                  {!!publishedArticle.html && (
                    <div
                      id="content-html"
                      className={`media-help-artical-content published-article-content ${
                        _markingShow ? `h-[100vh] overflow-hidden` : ""
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: publishedArticle.html,
                      }}
                    />
                  )}
                </div>
                <div className="pc:hidden pad:hidden mb-[8px]">
                  {markingShow && <Marking />}
                </div>
                {frogArticle.frogArticleId && (
                  <ShareComp frogArticle={frogArticle} />
                )}
              </div>
              <ArticleSwitch
                frogArticleId={frogArticle?.frogArticleId}
                type={querys.type}
                source={querys.source}
              />
            </div>
          </div>
          <div className="pc:w-[370px] shrink-0 mo:w-[100%] pad:w-[280px] ">
            <div className="__cate-list bg-[#FAFAFA] p-[20px] mb-[20px]">
              <ArticalCategory />
              <div className="mt-[40px]">
                <HotArticalList isShowHeaderIcon />
              </div>
            </div>
            {(publishedArticle.headings.length > 0 || isCkbEditor) && (
              <div className="mt-[20px] sticky top-[166px] pad:!top-[50px]">
                <div className="mo:hidden">
                  <ArticleTableOfContents
                    headings={publishedArticle.headings}
                    lang={lang as Local}
                    title={frogArticle?.frogArticleTitle}
                  />
                </div>
                {isCkbEditor && <FixedBanner />}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mo:hidden">{markingShow && <Marking />}</div>
    </>
  );
};

export default memo(ArticlesCont);
